import { toast } from "react-toastify";
import ErrorResponse from "../model/ErrorResponse";

const errorHandler = (error) => {
    let err = {...error};
    err = error;
    if (err === "Duplicate field value entered") {
        err = new ErrorResponse("User already exists!");
    } else if (err === "Must have 8 characters") {
        err = new ErrorResponse(`Password is too short! ${error}`);
    } else {
        err = new ErrorResponse(error);
    }
    toast.error(err.message);
};

export default errorHandler;